<template>
  <div class="yewu">
    <h1>{{$t('home.comBusiness')}}</h1>
    <div class="yewu-area">
      <div class="yewu-area-left">
        <img
          class="yewu-area-left-bg"
          v-if="this.sonCurrentIndex=='1-1'"
          src="@/assets/images/maijia-bg.jpg"
          alt
        />
        <img
          class="yewu-area-left-bg"
          v-if="this.sonCurrentIndex=='1-2'"
          src="@/assets/images/maimeng-bg.jpg"
          alt
        />
        <img
          class="yewu-area-left-bg"
          v-if="this.sonCurrentIndex=='2-1'"
          src="@/assets/images/shaomai-bg.jpg"
          alt
        />
        <img
          class="yewu-area-left-bg"
          v-if="this.sonCurrentIndex=='3-1'"
          src="@/assets/images/mailang-bg.jpg"
          alt
        />
        <img
          class="yewu-area-left-bg"
          v-if="this.sonCurrentIndex=='2-3'"
          src="@/assets/images/youmai-bg.jpg"
          alt
        />
        <img
          class="yewu-area-left-bg"
          v-if="this.sonCurrentIndex=='4-1'"
          src="@/assets/images/youmai-bg.jpg"
          alt
        />
        <img
          class="yewu-area-left-bg"
          v-if="this.sonCurrentIndex=='5-1'"
          src="@/assets/images/maitian-bg.jpg"
          alt
        />

        <transition name="left-detail">
          <div class="yewu-area-left-yewu-detail" v-if="this.sonCurrentIndex=='1-1'">
            <img src="@/assets/images/maijia.png" alt />
            <p>{{$t('home.MaiJiaUniverseTitle')}}</p>
            <div>
              <p>{{$t('home.MaiJiaUniverseContent1')}}</p>
              <p>{{$t('home.MaiJiaUniverseContent2')}}</p>
              <p>{{$t('home.MaiJiaUniverseContent3')}}</p>
            </div>
            <a href="https://www.duomai.cn/MaiJiaAdvertising" target="_blank">
              <span>{{$t('home.detail')}}</span>
              <img src="@/assets/images/arrow.png" alt />
            </a>
          </div>
        </transition>
        <transition name="left-detail">
          <div class="yewu-area-left-yewu-detail" v-if="this.sonCurrentIndex=='1-2'">
            <img src="@/assets/images/maimeng.png" alt />
            <p>{{$t('home.MaiMengTitle')}}</p>
            <div>
              <p>{{$t('home.MaiMengContent1')}}</p>
              <p>{{$t('home.MaiMengContent2')}}</p>
            </div>
            <a href="https://www.duomai.com" target="_blank">
              <span>{{$t('home.detail')}}</span>
              <img src="../../assets/images/arrow.png" alt />
            </a>
          </div>
        </transition>
        <transition name="left-detail">
          <div class="yewu-area-left-yewu-detail" v-if="this.sonCurrentIndex=='2-1'">
            <img src="@/assets/images/shaomai.png" alt />
            <p>{{$t('home.shaomaiTitle')}}</p>
            <div>
              <p>{{$t('home.shaomaiContent1')}}</p>
              <p>{{$t('home.shaomaiContent2')}}</p>
              <p>{{$t('home.shaomaiContent3')}}</p>
            </div>
          </div>
        </transition>
        <transition name="left-detail">
          <div class="yewu-area-left-yewu-detail" v-if="this.sonCurrentIndex=='2-3'">
            <img src="@/assets/images/youmai.png" alt />
            <p>{{$t('home.youmaiTitle')}}</p>
            <div>
              <p>{{$t('home.youmaiContent')}}</p>
            </div>
            <!-- <a href="http://www.duomai.cn/RuJiaCulture" target="_blank">
              <span>{{$t('home.detail')}}</span>
              <img src="../../assets/images/arrow.png" alt />
            </a> -->
          </div>
        </transition>
        <transition name="left-detail">
          <div class="yewu-area-left-yewu-detail" v-if="this.sonCurrentIndex=='3-1'">
            <img src="@/assets/images/mailang.png" alt />
            <p>{{$t('home.mailangTitle')}}</p>
            <div>
              <p>{{$t('home.mailangContent1')}}</p>
              <p>{{$t('home.mailangContent2')}}</p>
            </div>
            <!-- <a href="http://www.duomai.cn/RuJiaCulture" target="_blank">
              <span>{{$t('home.detail')}}</span>
              <img src="../../assets/images/arrow.png" alt />
            </a> -->
          </div>
        </transition>
        <transition name="left-detail">
          <div class="yewu-area-left-yewu-detail" v-if="this.sonCurrentIndex=='4-1'">
            <!-- <img src="@/assets/images/maitian.png" alt /> -->
            <span>小麦电商</span>
            <p>{{$t('home.xiaomaiTitle')}}</p>
            <div>
              <p>{{$t('home.xiaomaiContent')}}</p>
            </div>
          </div>
        </transition>
        <transition name="left-detail">
          <div class="yewu-area-left-yewu-detail left-detail6" v-if="this.sonCurrentIndex=='5-1'">
            <img src="@/assets/images/maitian.png" alt />
            <p>{{$t('home.maitianTitle')}}</p>
            <div>
              <p>{{$t('home.maitianContent')}}</p>
            </div>
          </div>
        </transition>
        <transition name="right-title">
          <div class="yewu-area-left-yewu-title" v-if="currentIndex=='1'">
            <div></div>
            
            <ul>
              <li @click="handleSonClick('1-1')">
                <a :class="{'son-current':sonCurrentIndex == '1-1'}">
                  <pre>{{$t('home.MaiJiaUniverse')}}</pre>
                </a>
              </li>
              <li @click="handleSonClick('1-2')">
                <a :class="{'son-current':sonCurrentIndex == '1-2'}">
                  <pre>{{$t('home.MaiMeng')}}</pre>
                </a>
              </li>
            </ul>
          </div>
        </transition>
        <transition name="right-title">
          <div class="yewu-area-left-yewu-title" v-if="currentIndex=='2'">
            <div></div>
            <ul>
              <li @click="handleSonClick('2-1')">
                <a :class="{'son-current':sonCurrentIndex == '2-1'}">
                  <pre>{{$t('home.shaomai')}}</pre>
                </a>
              </li>
              <!-- <li @click="handleSonClick('2-3')">
                <a :class="{'son-current':sonCurrentIndex == '2-3'}">
                  <pre>{{$t('home.youmai')}}</pre>
                </a>
              </li> -->
            </ul>
          </div>
        </transition>
        <transition name="right-title">
          <div class="yewu-area-left-yewu-title" v-if="currentIndex=='3'">
            <div></div>
            <ul>
              <li @click="handleSonClick('3-1')">
                <a :class="{'son-current':sonCurrentIndex == '3-1'}">
                  <pre>{{$t('home.mailang')}}</pre>
                </a>
              </li>
            </ul>
          </div>
        </transition>
        <transition name="right-title">
          <div class="yewu-area-left-yewu-title" v-if="currentIndex=='4'">
            <div></div>
            <ul>
              <li @click="handleSonClick('4-1')">
                <a :class="{'son-current':sonCurrentIndex == '4-1'}">
                  <pre>{{$t("home.xiaomai")}}</pre>
                </a>
              </li>
            </ul>
          </div>
        </transition>
        <transition name="right-title">
          <div class="yewu-area-left-yewu-title" v-if="currentIndex=='5'">
            <div></div>
            <ul>
              <li @click="handleSonClick('5-1')">
                <a :class="{'son-current':sonCurrentIndex == '5-1'}">
                  <pre>{{$t("home.maitian")}}</pre>
                </a>
              </li>
            </ul>
          </div>
        </transition>
      </div>
      <ul class="yewu-area-right">
        <div class="check-shadow" :style="{top:checkShadowTop,}">
          <img src="../../assets/images/select.png" alt />
        </div>
        <li :class="{'parent-current':currentIndex=='1'}">
          <div
            @click="handleParentYewu"
            @mouseover="handleMouseOver"
            @mouseout="handleMouseOut"
            data-index="1"
          >{{$t('home.MaiJiaAd')}}</div>
        </li>
        <li :class="{'parent-current':currentIndex=='2'}">
          <div
            @click="handleParentYewu"
            @mouseover="handleMouseOver"
            @mouseout="handleMouseOut"
            data-index="2"
          >{{$t('home.organization')}}</div>
        </li>
        <li :class="{'parent-current':currentIndex=='3'}">
          <div
            @click="handleParentYewu"
            @mouseover="handleMouseOver"
            @mouseout="handleMouseOut"
            data-index="3"
          >{{$t('home.liveStreaming')}}</div>
        </li>
        <li :class="{'parent-current':currentIndex=='4'}">
          <div
            @click="handleParentYewu"
            @mouseover="handleMouseOver"
            @mouseout="handleMouseOut"
            data-index="4"
          >{{$t('home.electronic')}}</div>
        </li>
        <li :class="{'parent-current':currentIndex=='5'}">
          <div
            @click="handleParentYewu"
            @mouseover="handleMouseOver"
            @mouseout="handleMouseOut"
            data-index="5"
          >{{$t('home.technicalServices')}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: "1",
      sonCurrentIndex: "1-1",
      yewuList: [
        {
          name: "麦加广告",
          index: "1"
        },
        {
          name: "MCN机构",
          index: "2"
        },
        {
          name: "技术服务",
          index: "3"
        }
      ],
      checkShadowTop: "0px"
    };
  },

  methods: {
    //父级业务点击事件
    handleParentYewu(e) {
      this.currentIndex = e.target.dataset.index;
      this.sonCurrentIndex = `${this.currentIndex}-1`;
      this.checkShadowTop =
        this.currentIndex == 1
          ? "0px"
          : this.currentIndex == 2
          ? "96px"
          : this.currentIndex == 3
          ? "192px"
          : this.currentIndex == 4
          ? "288px"
          : "384px";
    },

    //鼠标移动到div 选中状态样式修改
    handleMouseOver(e) {
      const diff = 400;
      const now = new Date();
      if (this.lastTime == null || now - this.lastTime < diff) {
        this.lastTime = now;
        //清除鼠标停止移动定时器
        this.timer && clearTimeout(this.timer);
        //定义鼠标 停止移动执行函数
        this.timer = setTimeout(() => {
          this.currentIndex = e.target.dataset.index;
          this.sonCurrentIndex = `${this.currentIndex}-1`;
          this.checkShadowTop =
            this.currentIndex == 1
              ? "0px"
              : this.currentIndex == 2
              ? "96px"
              : this.currentIndex == 3
              ? "192px"
              : this.currentIndex == 4
              ? "288px"
              : "384px";
          this.lastTime = null;
        }, diff);
      }
    },

    //鼠标离开当前div
    handleMouseOut() {
      if (new Date() - this.lastTime < 400) {
        this.timer && clearTimeout(this.timer);
        this.lastTime = null;
      }
    },

    handleSonClick(index) {
      this.sonCurrentIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.yewu {
  width: 1200px;
  margin: auto;
  padding: 64px 0 80px;
  overflow: hidden;
  & h1 {
    margin-bottom: 32px;
  }
  & .yewu-area {
    height: 480px;
    display: flex;
    position: relative;

    & .yewu-area-left {
      display: flex;
      width: 880px;
      & .yewu-area-left-bg {
        position: absolute;
        height: 480px;
        width: 880px;
        z-index: 1;
      }
      & .yewu-area-left-yewu-detail {
        flex: 1;
        padding: 62px 76px 0 64px;
        z-index: 2;
        & > img {
          width: 160px;
          height: 36px;
          display: block;
        }
        & > span {
          font-size: 24px;
          color: #fff;
        }
        & > p {
          font-size: 32px;
          color: #ffffff;
          line-height: 32px;
          padding: 25px 0 28px;
        }

        & > div:nth-child(3) {
          font-size: 14px;
          color: #ffffff;
          opacity: 0.8;
          margin-bottom: 20px;
          line-height: 28px;
        }
        & > a:nth-child(4) {
          width: 124px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #ffffff;
          border-radius: 20px;
          & > span {
            font-size: 16px;
            color: #ffffff;
            line-height: 16px;
          }
          & > img {
            width: 20px;
            height: 20px;
            display: block;
            margin-left: 8px;
          }
        }
      }
      & .yewu-area-left-yewu-title {
        width: 120px;
        position: relative;
        z-index: 2;
        & > div {
          width: 120px;
          height: 480px;
          background-color: #000;
          opacity: 0.15;
          position: absolute;
          z-index: 1;
        }

        & > ul {
          width: 120px;
          height: 480px;
          position: absolute;
          top: 0;
          z-index: 2;
          padding-top: 128px;
          box-sizing: border-box;
          & li {
            text-align: center;
            font-size: 20px;
            color: #ffffff;
            padding-bottom: 84px;
            cursor: pointer;
            & pre {
              font-family: PingFangSC-Regular;
            }
            & a:hover {
              color: #ff9900;
            }
            & .son-current {
              color: #ff9900;
            }
          }
        }
      }
    }
    & .yewu-area-right {
      position: relative;
      width: 320px;
      z-index: 3;
      & .check-shadow {
        width: 320px;
        height: 96px;
        position: absolute;
        left: 0;
        background-color: #ff9200;
        z-index: 1;
        transition: top 0.5s;
        & img {
          position: absolute;
          top: 0;
          left: -5px;
          height: 96px;
        }
      }

      & .parent-current {
        color: #fff;
        & div {
          font-size: 24px;
          animation: font-active 0.5s;
        }
      }

      & > li {
        height: 96px;
        line-height: 96px;
        text-align: center;
        font-size: 20px;
        color: #242424;
        position: relative;
        & > div {
          position: relative;
          z-index: 2;
          cursor: pointer;
        }
      }
      & > li:nth-of-type(odd) {
        background-color: #f7f7f7;
      }
      & > li:nth-of-type(even) {
        background-color: #fff;
      }
    }
  }
}

.left-detail-enter-active {
  animation: left-detail-in 1s;
}
.left-detail-leave-active {
  display: none;
}

.right-title-enter-active {
  animation: right-title-in 1s;
}

.right-title-leave-active {
  display: none;
}

@keyframes left-detail-in {
  0% {
    transform: translateX(-760px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}
@keyframes right-title-in {
  0% {
    transform: translateX(120px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes font-active {
  0% {
    opacity: 0;
    font-size: 20px;
  }
  100% {
    opacity: 1;
    font-size: 24px;
  }
}
</style>